import {Space as AntSpace} from "antd";

export const Space = AntSpace;
export default Space;
